import * as React from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router';
import {IHistory} from '../../interfaces';
import {ModuleModel} from '../../model/ModuleModel';
import {UserModel} from '../../model/UserModel';
import {getAllModules, getLibraryModules, RequestLibraryModules, saveLibraryModules} from '../../services/moduleService';
import {getUserData} from '../../services/utilityServices';
import {isArrayEmpty, parseJwt} from '../../utils/generalUtils';
import {Async} from '../reusableComponents/Async';
import {BasePage} from '../reusableComponents/BasePage';
import {Icon} from '../reusableComponents/Icon';
import {ListPage} from '../reusableComponents/ListPage';
import {Loader} from '../reusableComponents/Loader/Loader';
import {DeleteModuleDialog} from './DeleteModuleDialog';
import {ListItem} from './ListItems';
import { CategoryFilter } from './CategoryFilter';
import Dialog from 'material-ui/Dialog';
import {PerfectScrollbar} from '../reusableComponents/PerfectScrollbar';
import { FormFooter } from '../reusableComponents/FormComponents/FormFooter';
import { RaisedButton } from 'material-ui';
import { TextColor } from 'src/constants/generals';


export interface IModuleListPageProps {
    instances: ModuleModel[];
    history: IHistory;
    userInstance: UserModel;
    userUID: string;
    selectedListItems: string[];
    Category: [];
    SubCategory:[];
    CompletedStatus: string;
}

export interface IModuleListPageState {
    open: boolean;
    isLoading: boolean;
    searchInput: string;
    isInfoOpen: boolean;
    libraryModules: string[];
    resetLibraryModules: string[];
    selLibraryModules: string[];
    parentModuleId : string[];
}

export class ModuleListPageImpl extends React.PureComponent<IModuleListPageProps, IModuleListPageState> {
    constructor(props: IModuleListPageProps) {
        super(props);
        this.state = {isLoading: false, open: false, searchInput: '', isInfoOpen: false, libraryModules: [], selLibraryModules: [], parentModuleId: [], resetLibraryModules: []};
    }

    public promise = async () => {
        const isAdmin = UserModel.isAdmin(this.props.userInstance);
        const isSuperAdmin = UserModel.isSuperAdmin(this.props.userInstance);
        let libmodules;
        await getAllModules(isAdmin || isSuperAdmin ? '' : this.props.userUID);
        if (isAdmin) {
            let arr = [];
            for ( let j = 0; j < this.props.instances.length; j++ ) {
                // arr.push(this.props.instances[j].props);
                let props =  this.props.instances[j].props.ParentId;
                if ( props !== null ) {
                    arr.push(props);
                }
            }
        }
    }
    public fLoadLibrary = async () => {
        this.setState({
            libraryModules: [],
            selLibraryModules: [],
            isInfoOpen: true,
            isLoading:true
            // selLibraryModules: selectedLibrary
        });

        let libmodules = await getLibraryModules();
        this.setState({
            libraryModules: libmodules,
            isLoading: false
        });

    }
    public handleLibraryRequest = async (moduleId, moduleName) => {
        const libmodules = [];
        const sellibmodules = [];
        const selectedLibrary = this.state.selLibraryModules.length > 0 ? this.state.selLibraryModules : [];
        const moduleLibrary = this.state.libraryModules;
        let arr = [];
        for ( let j = 0; j < moduleLibrary.length; j++ ) {
            arr.push(moduleLibrary[j]);
            let ObjKeys = Object.keys(moduleLibrary[j]);
                if ( arr[j].ModuleID === moduleId ) {
                    // let newarr = arr[j + 1];
                    sellibmodules.push(moduleLibrary[j]);
                    selectedLibrary.push(moduleLibrary[j]);

                }else{
                    libmodules.push(moduleLibrary[j]);
                }
                
        }
        const userData = getUserData();
        await this.setState({
            isLoading: true
        });
        await RequestLibraryModules(moduleId, moduleName);
        this.setState({
            libraryModules: libmodules,
            selLibraryModules: selectedLibrary,
            isLoading: false
        });
        return moduleId;

    }
    public handleLibraryList = (moduleId) => {
        const libmodules = [];
        const selectedLibrary = this.state.selLibraryModules.length > 0 ? this.state.selLibraryModules : [];
        // selectedLibrary.push(moduleId);
        const moduleLibrary = this.state.libraryModules;
        let arr = [];
        for ( let j = 0; j < moduleLibrary.length; j++ ) {
            arr.push(moduleLibrary[j]);
            let ObjKeys = Object.keys(moduleLibrary[j]);
                if ( arr[j].ModuleID === moduleId ) {
                    // let newarr = arr[j + 1];
                    selectedLibrary.push(moduleLibrary[j]);

                }else{
                    libmodules.push(moduleLibrary[j]);
                }

        }
        this.setState({
            libraryModules: libmodules,
            selLibraryModules: selectedLibrary
        });
        return moduleId;
    }
    public handleRemoveLibraryList = async (moduleId) => {
        const libmodules = [];
        const selectedLibrary = this.state.selLibraryModules.length > 0 ? this.state.selLibraryModules : [];
        const moduleLibrary = this.state.libraryModules;

        let arr = [];
        for ( let j = 0; j < selectedLibrary.length; j++ ) {
            arr.push(selectedLibrary[j]);
            let ObjKeys = Object.keys(selectedLibrary[j]);
                if ( arr[j].ModuleID === moduleId ) {
                    moduleLibrary.push(selectedLibrary[j]);
                }else{
                    libmodules.push(selectedLibrary[j]);
                }
        }

        await this.setState({
            libraryModules: moduleLibrary,
            selLibraryModules: libmodules
        });
        return moduleId;
    }
    
    public submitSelectedLibrary = async (selLibraryModules) => {
        const selectedLibrary = this.state.selLibraryModules;
        if (isArrayEmpty(selLibraryModules, 'Please Select Library Module For Adding.')) {
            return;
        }
        this.setState({
            isLoading:true
        });
        await saveLibraryModules(selLibraryModules, this.props.history);
    }

    public renderUserModulesInfo = () => {
        const pndIcon = <Icon icon="exclamation-triangle" />;
        const compIcon = <Icon icon="check-circle" />;
        const plusIcon = <Icon icon="plus" />;
        const submitStyle: React.CSSProperties = {
            backgroundColor: TextColor
        };  
        if ( this.state.isInfoOpen === false) {
            return;
        }
        return <Dialog
            bodyStyle={dialogBodyStyle}
            titleStyle={dialogTitleStyle}
            title={'Library Modules'}
            modal={false}
            onRequestClose={() => this.setState({isInfoOpen: false})}
            open={this.state.isInfoOpen}
        >
            <div className="user-module-details">
                <PerfectScrollbar className="list-page-container">
                    <div key={'header'} className="module-item table-head">
                        {/* <div className="module-name grid-title">#</div> */}
                        <div className="module-name grid-title">Module Name</div>
                        {/* <div className="module-name grid-title">
                            Status
                        </div> */}
                        <div className="module-name grid-title">Category</div>
                        <div className="module-name grid-title">Training Duration</div>
                        {/* <div className="module-name grid-title">Created Date</div> */}
                        <div className="module-name grid-title">Action</div>
                    </div>
                    {this.state.selLibraryModules.map((moduleDatas : any, index) => {
                        return <div key={index} className="module-item table-row">
                            {/* <div key={index} className="module-name">{index}</div> */}
                            <div key={moduleDatas.Name + index} className="module-name">{moduleDatas.Name}</div>
                            <div key={moduleDatas.Category + index} className="module-name">{moduleDatas.Category}</div>
                            <div key={moduleDatas.TrainingDuration + moduleDatas.ModuleID} className="module-name">{moduleDatas.TrainingDuration + ' Days'}</div>
                            {/* <div key={moduleDatas.DateCreated + index} className="module-name">{moduleDatas.DateCreated}</div> */}
                            {/* <div key={moduleDatas.DateCreated + index}  className="module-name Cancel-Icon">{<Icon icon="times" onClick={() => this.handleRemoveLibraryList(moduleDatas.ModuleID)} />}</div> */}
                            {/* <div key={moduleDatas.DateCreated + index}  className="module-name cancel-label">{<label>Requested</label>}</div> */}
                            <div key={moduleDatas.DateCreated + index}  className="module-name cancel-label">{<Icon icon="clock"/>}</div>


                        </div>;
                    })}
                    {this.state.libraryModules.map((moduleDatas : any, index) => {
                        return <div key={index} className="module-item table-row">
                            {/* <div key={index} className="module-name">{index}</div> */}
                            <div key={moduleDatas.Name + index} className="module-name">{moduleDatas.Name}</div>
                            <div key={moduleDatas.Category + index} className="module-name">{moduleDatas.Category}</div>
                            <div key={moduleDatas.TrainingDuration + moduleDatas.ModuleID} className="module-name">{moduleDatas.TrainingDuration + ' Days '}</div>
                            {/* <div key={moduleDatas.DateCreated + index} className="module-name">{moduleDatas.DateCreated}</div> */}
                            {/* <div key={moduleDatas.DateCreated + index}  className="module-name Add-Icon">{moduleDatas.Flag ? <Icon icon="check-circle"  /> : <Icon icon="plus" onClick={() => this.handleLibraryRequest(moduleDatas.ModuleID)} />}</div> */}
                            <div key={moduleDatas.DateCreated + index}  className="module-name Add-Icon">{moduleDatas.Flag ? <Icon icon="check-circle"  /> : moduleDatas.RequestFlag == 'NotSelected' ? <Icon icon="plus" onClick={() => this.handleLibraryRequest(moduleDatas.ModuleID, moduleDatas.Name)} /> :<div className="module-name Cancel-Icon" >{ moduleDatas.RequestFlag == 'Rejected' ? <Icon icon="times"/> : moduleDatas.RequestFlag == 'Approved' ? <Icon icon="check-circle"/> : <Icon icon="clock"/> }</div>}</div>
                        </div>;
                    })}
                </PerfectScrollbar>
            </div>
            <div className="library-module" >
            <RaisedButton
                    type="submit"
                    style={{
                        backgroundColor: TextColor,
                    }}
                    onClick= {() => this.submitSelectedLibrary(this.state.selLibraryModules)}
                    className="submit-button submit-raised-btn  btn-placement"
                    label="Submit"
                    primary={true}
                />
                <RaisedButton
                    type="submit"
                    style={{
                        backgroundColor: TextColor,
                    }}
                    onClick= {() => this.setState({isInfoOpen: false})}
                    className="cancel-button cancel-raised-btn  btn-placement"
                    label="Cancel"
                />
                </div>
                {this.state.isLoading ? <Loader type="submission"/> : ''}
        </Dialog>;
    }
    public renderModuleList = () => {
        const isAdmin = UserModel.isAdmin(this.props.userInstance);
        const isSuperAdmin = UserModel.isSuperAdmin(this.props.userInstance);
        const instances = this.props.instances;
        return <ListPage
            instances={this.props.instances}
            defaultSort = {isAdmin ? 1 : 3}
            listItemComponent={ListItem}
            searchPlaceHolder="Enter to search..."
            searchBy={isAdmin || isSuperAdmin ? ['#', 'Name', 'Category', 'TrainingDuration', 'DateCreated'] : ['#', 'ModuleName', 'Category', 'TrainingDuration', 'DueDate', 'Completed', 'DateCompleted']}
            pageHeadings={isAdmin || isSuperAdmin ?
                ['#', 'Module Name', 'Category', 'Trg Duration', 'Date Created', 'Edit', 'Delete'] : ['#', 'Module Name', 'Category', 'Trg Duration', 'Due Date', 'Status', 'Completed On']}
            isSearchable={true}
            promise={this.promise}
            cols={isAdmin ? [1, 2, 2, 2, 2, 1, 1] : [1, 2, 2, 2, 2, 1, 1]}
            emptyListMessage="No Modules Available"
            chartTitle = "TrainingModuleList"
        />;
    }

    public handleDeleteListItems = () => {
        this.setState({
            open: true
        });
    }

    public handleSubmit = async (values: IModuleListPageProps ) => {
        let searchInputs = '';
        searchInputs = values.Category.toString();
        await this.setState({
            searchInput: searchInputs
        });
        return;
    }


    public render() {
        const isAdmin = UserModel.isAdmin(this.props.userInstance);
        const isSuperAdmin = UserModel.isSuperAdmin(this.props.userInstance);

        const {selectedListItems} = this.props;
        return <BasePage title="Training Module List" className="list-page-with-edit-delete" icon="chalkboard-teacher">
                {this.renderUserModulesInfo()}
            <DeleteModuleDialog
                onClose={() => this.setState({open: false})}
                open={this.state.open}
                textToDisplay={`all ${selectedListItems.length} modules`}
                moduleIds={selectedListItems}
                history={this.props.history}
            />
            <Async
                identifier="ModuleListPage"
                promise={this.promise}
                loader={<Loader type="async"/>}
                content={this.renderModuleList()}
                error={<Loader type="async"/>}
            />
            {isAdmin || isSuperAdmin ?
                <div className="options-container">
                    {selectedListItems.length > 0 ?
                        <div className="delete" onClick={this.handleDeleteListItems}>
                            <Icon icon="trash"/>
                            &nbsp;
                            Delete
                        </div>
                        : ''}
                    <div className="add-new" onClick={() => this.props.history.push('/training/create')}>
                        <Icon icon="plus"/>
                        &nbsp;
                        Add New
                    </div>
                    {isAdmin ?
                        <div className="add-new" onClick={() => this.fLoadLibrary()} >
                            <Icon icon="plus"/>
                            &nbsp;
                            Add From Library
                        </div>
                    :''}
                </div>
                : ''}
        </BasePage>;
    }
}

export function mapStateToProps(state) {
    const userUID = state.login.get('token') ? parseJwt(state.login.get('token')).UniqueID : getUserData().userUID;
    return {
        userUID,
        instances: ModuleModel.list().reverse(),
        selectedListItems: state.forms.selectedListItems.listItems,
        userInstance: UserModel.get(userUID)

    };
}
const dialogBodyStyle: React.CSSProperties = {
    backgroundColor: '#003152',
    color: 'white',
    // width: '80%'
};

const actionsContainerStyle: React.CSSProperties = {
    backgroundColor: '#003152',
    // width: '80%'
};

const dialogTitleStyle: React.CSSProperties = {
    backgroundColor: '#a4bf43',
    color: '#fdfcfc',
    // width: '80%'
};

export const ModuleListPage =
    withRouter(connect<{}, {}, IModuleListPageProps>(mapStateToProps)(ModuleListPageImpl) as any);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Modules/ModuleListPage.tsx